var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: !0 });
import { ref, createApp, createVNode } from "vue";
import { onKeyDown } from "../node_modules/.pnpm/@vueuse_core@13.3.0_vue@3.5.16_typescript@5.8.3_/node_modules/@vueuse/core/index.js";
import _sfc_main from "../components/ui/config-provider/ConfigProvider.vue.js";
import "../node_modules/.pnpm/@uppy_locales@4.5.2/node_modules/@uppy/locales/lib/en_US.js";
import "../components/ui/tooltip/styles/index.js";
import _sfc_main$1 from "../components/ui/tooltip/wrapper/TooltipWrapper.vue.js";
const tooltipMap = /* @__PURE__ */ new WeakMap();
function getPlacement(binding) {
  if (binding.modifiers.top) return "top";
  if (binding.modifiers.bottom) return "bottom";
  if (binding.modifiers.left) return "left";
  if (binding.modifiers.right) return "right";
}
__name(getPlacement, "getPlacement");
function isBindingValueNil(binding) {
  return binding.value === void 0 || binding.value === null || binding.value === "";
}
__name(isBindingValueNil, "isBindingValueNil");
function bindPointerEvent(rootContainer, el, valueRef) {
  function handlePointerEnter() {
    valueRef.value = !0;
  }
  __name(handlePointerEnter, "handlePointerEnter");
  function handlePointerLevel() {
    valueRef.value = !1;
  }
  __name(handlePointerLevel, "handlePointerLevel");
  const bindTriggerElement = rootContainer.querySelector('[data-slot="tooltip-trigger"]');
  let removeListenerFn = null;
  return bindTriggerElement && (bindTriggerElement.addEventListener("pointerenter", handlePointerEnter), bindTriggerElement.addEventListener("pointerleave", handlePointerLevel), el.addEventListener("focus", handlePointerEnter), el.addEventListener("blur", handlePointerLevel), removeListenerFn = onKeyDown("Escape", handlePointerLevel)), function() {
    const unBindTriggerElement = rootContainer.querySelector('[data-slot="tooltip-trigger"]');
    unBindTriggerElement && (unBindTriggerElement.removeEventListener("pointerenter", handlePointerEnter), unBindTriggerElement.removeEventListener("pointerleave", handlePointerLevel), el.removeEventListener("focus", handlePointerEnter), el.removeEventListener("blur", handlePointerLevel), removeListenerFn == null || removeListenerFn());
  };
}
__name(bindPointerEvent, "bindPointerEvent");
function createTooltipApp({
  el,
  binding,
  placement,
  vnode,
  open
}) {
  return createApp({
    render() {
      var _a;
      return createVNode(_sfc_main, {
        directivesProvides: (_a = vnode == null ? void 0 : vnode.ctx) != null && _a.provides ? {
          ...vnode.ctx.provides
        } : void 0
      }, {
        default: /* @__PURE__ */ __name(() => [createVNode(_sfc_main$1, {
          content: binding.value,
          placement,
          reference: el,
          open: open.value,
          usedInDirectives: !0
        }, {
          default: /* @__PURE__ */ __name(() => [createVNode("div", {
            "data-tooltip-children": !0,
            style: "display: contents;"
          }, null)], "default")
        })], "default")
      });
    }
  });
}
__name(createTooltipApp, "createTooltipApp");
function createTooltipDirectivesRunner(el, binding, vnode) {
  var _a, _b;
  el.dataset.tooltipProcessed = "true";
  const rootContainer = document.createElement("div");
  rootContainer.style.display = "contents", el.parentElement && el.parentElement.insertBefore(rootContainer, el);
  const placement = getPlacement(binding), open = ref(!1), app = createTooltipApp({
    el,
    binding,
    placement,
    vnode,
    open
  });
  app.mount(rootContainer), (_b = (_a = rootContainer.querySelector("[data-tooltip-children]")) == null ? void 0 : _a.appendChild) == null || _b.call(_a, el), tooltipMap.set(el, {
    container: rootContainer,
    content: binding.value,
    placement,
    app,
    open,
    cleanup: bindPointerEvent(rootContainer, el, open)
    // 在原始元素上直接监听pointer事件
  });
}
__name(createTooltipDirectivesRunner, "createTooltipDirectivesRunner");
function updateTooltipDirectivesRunner(tooltipInfo, el, binding, vnode) {
  var _a, _b;
  const placement = getPlacement(binding);
  if (!(tooltipInfo.content !== binding.value || tooltipInfo.placement !== placement)) return;
  tooltipInfo.cleanup(), el.remove(), tooltipInfo.app.unmount(), tooltipInfo.container.innerHTML = "";
  const app = createTooltipApp({
    el,
    binding,
    placement,
    vnode,
    open: tooltipInfo.open
  });
  app.mount(tooltipInfo.container), (_b = (_a = tooltipInfo.container.querySelector("[data-tooltip-children]")) == null ? void 0 : _a.appendChild) == null || _b.call(_a, el), tooltipInfo.app = app, tooltipInfo.content = binding.value, tooltipInfo.placement = placement, tooltipInfo.cleanup = bindPointerEvent(tooltipInfo.container, el, tooltipInfo.open);
}
__name(updateTooltipDirectivesRunner, "updateTooltipDirectivesRunner");
const tooltip = {
  mounted(el, binding, vnode) {
    isBindingValueNil(binding) || el.dataset.tooltipProcessed || createTooltipDirectivesRunner(el, binding, vnode);
  },
  updated(el, binding, vnode) {
    const tooltipInfo = tooltipMap.get(el);
    if (!tooltipInfo) return createTooltipDirectivesRunner(el, binding, vnode);
    updateTooltipDirectivesRunner(tooltipInfo, el, binding, vnode);
  },
  unmounted(el) {
    const tooltipInfo = tooltipMap.get(el);
    tooltipInfo && (tooltipInfo.cleanup(), tooltipInfo.app.unmount(), tooltipInfo.container.remove()), tooltipMap.delete(el);
  }
};
export {
  tooltip as default
};
//# sourceMappingURL=tooltip.js.map
